export default "__VITE_ASSET___app/immutable/assets/terminal-pointer-cursor.nYjGxEvf.svg__"